import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { environment } from 'src/environments/environment';
import { ActivityManagementService } from '../../activity-management.service';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Observable, Observer, of } from 'rxjs';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { Router } from '@angular/router';
import { AccountingService } from 'src/app/modules/accounting/accounting.service';
import { LearningCenterService } from 'src/app/modules/learning-center/learning-center.service';

@Component({
  selector: 'app-manage-workshop',
  templateUrl: './manage-workshop.component.html',
  styleUrls: ['./manage-workshop.component.scss'],
})
export class ManageWorkshopComponent implements OnInit {
  isEdit: boolean;
  workshopId: string = null;
  workshopData: any;
  workshopForm: FormGroup;
  workshopEditForm: FormGroup;
  isLoading: boolean = false;
  ismeridian: boolean = true;
  mytime: Date = new Date();
  workshopCover: string;
  workshopCoverSelected: string;
  workshopCoachPic: string;
  workshopCoachPicSelected: string;
  workshopDoc: string[] = null;
  fileList: NzUploadFile[] = []
  workshopDocDelete: number[] = []
  dateTimeRange = [];
  status;

  account: any;

  successRequest = ({ file, onSuccess, onError }) => {
    const fileType = this.gobalFunctionService.getTypeFile(file);

    if (fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' || fileType === 'xlsx' || fileType === 'csv') {
      setTimeout(() => {
        onSuccess("ok");
      }, 0);
    } else {
      setTimeout(() => {
        onError('error');
      }, 0);
    }
  };

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '250px',
    maxHeight: 'auto',
    width: '80%;',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'ใส่รายละเอียดกิจกรรมของคุณ',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      { class: 'th-sarabun', name: 'Sarabun' },
      { class: 'K2D', name: 'K2D' },
    ],
    uploadUrl: environment.URL + '/manage_admin/uploadImgaeContentNews',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top'
  }

  joinType = [
    {
      type: 'On-site'
    },
    {
      type: 'Online'
    }
  ];

  allLearningCenter: any[] = [];
  learningCenter: any;
  LN_TAG: any[] = [];

  constructor(
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private router: Router,
    private ActivityManagementService: ActivityManagementService,
    private gobalFunctionService: GobalFunctionService,
    private accountService: AccountingService,
    private learningCenterService: LearningCenterService,
  ) {
    this.workshopForm = this.fb.group({
      workshopName: ['', Validators.required],
      workshopCover: ['', Validators.required],
      workshopDoc: [''],
      workshopPlace: ['', Validators.required],
      workshopDateTime: this.fb.array([]),
      workshopCoach: ['', Validators.required],
      workshopCoachPic: ['', Validators.required],
      workshopPrice: ['', Validators.required],
      workshopQuantity: ['', Validators.required],
      workshopPhoneNO: ['', [Validators.required, Validators.pattern("(^02[0-9]{7}$)|(^06[0-9]{8}$)|(^08[0-9]{8}$)|(^09[0-9]{8}$)")]],
      workshopDetail: ['', Validators.required],
      workshopCoachAssit: [],
      joinType: ['', Validators.required],
      statusPublic: [false],
      accountId: ['', Validators.required],
      centerId: [''],
    })

    this.workshopEditForm = this.fb.group({
      workshopName: ['', Validators.required],
      workshopCover: [''],
      workshopDoc: [''],
      workshopPlace: ['', Validators.required],
      workshopDateTime: this.fb.array([]),
      workshopCoach: ['', Validators.required],
      workshopCoachPic: [''],
      workshopPrice: ['', Validators.required],
      workshopQuantity: ['', Validators.required],
      workshopPhoneNO: ['', [Validators.required, Validators.pattern("(^02[0-9]{7}$)|(^06[0-9]{8}$)|(^08[0-9]{8}$)|(^09[0-9]{8}$)")]],
      // "^(02)|(06)|(08)|(09)?[0-9]{7-8}$"
      workshopDetail: ['', Validators.required],
      workshopCoachAssit: [],
      joinType: ['', Validators.required],
      statusPublic: [''],
      accountId: ['', Validators.required],
      centerId: [''],
    })
  }

  ngOnInit(): void {

    this.isEdit = JSON.parse(new URL(location.href).searchParams.get('isEdit'));
    if (this.isEdit) {
      this.workshopId = new URL(location.href).searchParams.get('workshop_id');
      this.gobalFunctionService.setTitle('แก้ไข Workshop');

      if (this.workshopId) {
        this.ActivityManagementService.getWorkshopById(this.workshopId).subscribe(res => {
          this.workshopData = res.result;
          this.workshopCoachPic = this.workshopData.WORKSHOP_COACH_PICNAME;
          this.workshopCover = this.workshopData.WORKSHOP_PICNAME;
          this.status = JSON.parse(this.workshopData.STATUS_PUBLIC);
          // console.log(this.workshopData);
          this.LN_TAG = this.workshopData.LN_TAG;

          this.workshopData.WORKSHOP_DOC.map(f => {
            const file: NzUploadFile = {
              uid: f.DOC_ID,
              name: f.DOC_NAME,
              status: 'done',
              url: f.DOC_URL
            }
            this.fileList.push(file)
          })
          this.setDefaultDateTimeEdit(this.workshopData.WORKSHOP_DATE)
        }, err => {
          alert(err.error.message);
          this.router.navigate(['activity-management/workshop']);
        })
      }
    } else {
      this.gobalFunctionService.setTitle('สร้าง Workshop');
      this.addGroup(false);
    }
    this.getActiveAccount();
    this.getAllLearning();
  }

  get f() {
    return this.workshopForm.controls;
  }

  get fe() {
    return this.workshopEditForm.controls;
  }

  getActiveAccount() {
    this.accountService.getActiveAccount().pipe(
      map(a => {
        // console.log(a.result);
        this.account = a.result;
      })
    ).subscribe();
  }

  createWorkshop(w) {
    let isWrongDate: boolean = false;

    for (let i = 0; i < w.workshopDateTime.length; i++) {
      if (!isWrongDate && w.workshopDateTime[i].dateTime[1]) {
        if (w.workshopDateTime[i].dateTime[0].toISOString().slice(0, 10) !== w.workshopDateTime[i].dateTime[1].toISOString().slice(0, 10)) {
          isWrongDate = true;
        }
      }
    }

    if (w.workshopQuantity <= 50000 && w.workshopQuantity > 0 && !isWrongDate) {
      this.isLoading = true;

      this.ActivityManagementService.createWorkshop(w).pipe(
        switchMap(res => {

          if (res.success) {
            this.isLoading = false;
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            dialogConfig.id = 'modalConfirm';
            dialogConfig.width = '350px';
            dialogConfig.data = {
              title: 'สร้าง workshop สำเร็จแล้ว',
              description: `<img src="../../../assets/check.png" width="100px;" class="img-center">สร้าง "${w.workshopName}" สำเร็จแล้ว`,
              cancleBtnText: 'ยืนยัน',
              customStyle: 'background-color: #58595B;'
            }

            const modal = this.matDialog.open(ModalComponent, dialogConfig);
            return modal.afterClosed().pipe(
              map(res => {
                if (!res) {
                  window.opener.location.reload();
                  setTimeout(() => {
                    window.close()
                  }, 100);
                }
              })
            )
          }
        })
      ).subscribe();
    } else {
      if (isWrongDate) {
        alert('"วัน เวลาที่จัด workshop" ไม่ถูกต้อง เนื่องจากการจัด workshop แต่ละครั้งต้องเป็นวันเดียวกัน กรุณาลองใหม่อีกครั้ง');
      } else {
        alert('จำนวนผู้สมัครไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง');
      }
    }
  }

  editWorkshop(w) {
    let isWrongDate: boolean = false;

    // console.log(w);


    for (let i = 0; i < w.workshopDateTime.length; i++) {
      if (!isWrongDate && w.workshopDateTime[i].dateTime[1]) {
        if (w.workshopDateTime[i].dateTime[0].toISOString().slice(0, 10) !== w.workshopDateTime[i].dateTime[1].toISOString().slice(0, 10)) {
          isWrongDate = true;
        }
      }
    }

    if (w.workshopQuantity <= 50000 && w.workshopQuantity > 0 && w.workshopQuantity >= this.workshopData.COUNT_REGIS && !isWrongDate) {
      this.isLoading = true;

      this.ActivityManagementService.editWorkshop(w, this.workshopData.WORKSHOP_ID, this.workshopDocDelete).subscribe(res => {
        if (res.success) {
          this.isLoading = false;
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = true;
          dialogConfig.id = 'modalConfirm';
          dialogConfig.width = '350px';
          dialogConfig.data = {
            title: 'แก้ไข workshop สำเร็จแล้ว',
            description: `<img src="../../../assets/check.png" width="100px;" class="img-center">แก้ไข "${w.workshopName}" สำเร็จแล้ว`,
            cancleBtnText: 'ยืนยัน',
            customStyle: 'background-color: #58595B;'
          }

          const modal = this.matDialog.open(ModalComponent, dialogConfig);
          modal.afterClosed().subscribe(res => {
            if (!res) {
              window.opener.location.reload();
              setTimeout(() => {
                window.close()
              }, 100);
            }
          })
        }
      });
    } else {
      if (isWrongDate) {
        alert('"วัน เวลาที่จัด workshop" ไม่ถูกต้อง เนื่องจากการจัด workshop แต่ละครั้งต้องเป็นวันเดียวกัน กรุณาลองใหม่อีกครั้ง');
      } else {
        if (w.workshopQuantity < this.workshopData.COUNT_REGIS) {
          alert(`จำนวนผู้สมัครไม่ถูกต้อง เนื่องจากมีผู้สมัครไปแล้ว ${this.workshopData.COUNT_REGIS} คน กรุณาลองใหม่อีกครั้ง`);
        } else {
          alert('จำนวนผู้สมัครไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง');
        }
      }
    }
  }

  addGroup(isEdit: boolean) {
    if (isEdit) {
      (<FormArray>this.workshopEditForm.get("workshopDateTime")).push(this.fb.group({
        dateTime: ['', [Validators.required]],
      }));
    } else {
      (<FormArray>this.workshopForm.get("workshopDateTime")).push(this.fb.group({
        dateTime: ['', [Validators.required]],
      }));
    }
  }

  removeGroup(index, isEdit: boolean) {
    if (isEdit) {
      this.dateTimeRange.splice(index, 1);

      (<FormArray>this.workshopEditForm.get("workshopDateTime")).removeAt(index);
    } else {
      (<FormArray>this.workshopForm.get("workshopDateTime")).removeAt(index);
    }
  }

  onCoverSelected(e, workshopForm) {
    const fileType = this.gobalFunctionService.getTypeFile(e.target.files[0]);

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
      if (e.target.files && e.target.files[0]) {
        this.workshopCover = e.target.files[0].name;

        const file = (e.target as HTMLInputElement).files[0];

        workshopForm.patchValue({
          workshopCover: file
        });
        workshopForm.get('workshopCover').updateValueAndValidity()

        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (event) => {
          var file = new File([reader.result], <any>reader.result);
          this.workshopCoverSelected = file.name;
        }
      }
    } else {
      alert('การอัปโหลดรูปภาพรองรับไฟล์ JPG, JPEG, PNG เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  onCoachPicSelected(e, workshopForm) {
    const fileType = this.gobalFunctionService.getTypeFile(e.target.files[0]);

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
      if (e.target.files && e.target.files[0]) {
        this.workshopCoachPic = e.target.files[0].name;

        const file = (e.target as HTMLInputElement).files[0];

        workshopForm.patchValue({
          workshopCoachPic: file
        });
        workshopForm.get('workshopCoachPic').updateValueAndValidity()

        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (event) => {
          var file = new File([reader.result], <any>reader.result);
          this.workshopCoachPicSelected = file.name;
        }
      }
    } else {
      alert('การอัปโหลดรูปภาพรองรับไฟล์ JPG, JPEG, PNG เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]) => {
    return new Observable((observer: Observer<boolean>) => {
      const fileType = this.gobalFunctionService.getTypeFile(file);

      const isTypeFileCorrect = fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' || fileType === 'xlsx' || fileType === 'csv';
      if (!isTypeFileCorrect) {
        alert('การอัปโหลดเอกสารรองรับไฟล์ CSV, XLSX, PDF, DOC, DOCX เท่านั้น กรุณาลองใหม่อีกครั้ง');
        observer.complete();
        return;
      }
      observer.next(isTypeFileCorrect);
      observer.complete();
    });
  };

  handleChange(e, workshopForm) {
    // console.log(e);
    let fileList = [...e.fileList];
    const fileType = this.gobalFunctionService.getTypeFile(e.file);

    switch (e.file.status) {
      case 'done': {
        if (fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' || fileType === 'xlsx' || fileType === 'csv') {
          if (fileList.length > 5) {
            let removeExcess = [...fileList].splice(0, fileList.length - 5);

            e.fileList = fileList.slice(-5);

            for (let i = 0; i < removeExcess.length; i++) {
              if (removeExcess[i].uid) {
                this.workshopDocDelete.push(removeExcess[i].uid)
              }
            }
          }

          // upload 5 files เกิน 5 จะลบอันแรก
          fileList = fileList.slice(-5);
          fileList = fileList.map(file => {
            if (file.response) {
              file.url = file.response.url;
            }
            return file;
          });

          workshopForm.patchValue({
            workshopDoc: e
          });
          workshopForm.get('workshopDoc').updateValueAndValidity()

          this.fileList = fileList;
        }
        break;
      }

      case 'removed': {
        if (this.isEdit && typeof (e.file.uid) === 'number') {
          this.workshopDocDelete.push(e.file.uid)
        } else {
          workshopForm.patchValue({
            workshopDoc: e
          });
          workshopForm.get('workshopDoc').updateValueAndValidity()
        }
        break;
      }
    }
  }

  setDefaultDateTimeEdit(dateTime) {
    dateTime.map((dt) => {
      this.dateTimeRange.push([dt.dateTime[0] ? new Date(dt.dateTime[0]) : null, dt.dateTime[1] ? new Date(dt.dateTime[1]) : null]);

      (<FormArray>this.workshopEditForm.get("workshopDateTime")).push(this.fb.group({
        dateTime: [[dt.dateTime[0] ? new Date(dt.dateTime[0]) : null, dt.dateTime[1] ? new Date(dt.dateTime[1]) : null], [Validators.required]]
      }));
    })
  }

  delete(id, name) {
    this.isLoading = true;
    const confirmDelete = new MatDialogConfig();

    confirmDelete.autoFocus = false;
    confirmDelete.id = 'modalDeleteNews';
    confirmDelete.data = {
      title: 'คุณต้องการลบ workshop?',
      description: `ระบบจะทำการลบ "${name}" ออกจากระบบ คุณต้องการลบ ใช่หรือไม่?`,
      actionBtnText: 'ยืนยัน',
      cancleBtnText: 'ยกเลิก',
      isDelete: true
    }

    const modalDelete = this.matDialog.open(ModalComponent, confirmDelete);
    modalDelete.afterClosed().pipe(
      switchMap(isDelete => {
        if (isDelete) {
          return this.ActivityManagementService.deleteWorkshopById(id).pipe(
            switchMap(res => {
              if (res.success) {
                this.isLoading = false;
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.id = 'modalConfirm';
                dialogConfig.width = '350px';
                dialogConfig.data = {
                  title: 'ลบ workshop สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">ลบ "${name}" สำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal = this.matDialog.open(ModalComponent, dialogConfig);
                return modal.afterClosed().pipe(
                  map(res => {
                    if (!res) {
                      window.opener.location.reload();
                      setTimeout(() => {
                        window.close()
                      }, 100);
                    }
                  })
                )
              } else {
                alert(res.message);
                return of(null);
              }
            }),
            catchError((err) => {
              alert(err.error.message)
              this.isLoading = false;
              return of(null);
            }),
          )
        } else {
          this.isLoading = false;
          return of(null);
        }
      })
    ).subscribe()
  }

  patch(values, isEdit) {
    if (isEdit) {
      // edit workshop
      this.workshopEditForm.patchValue({
        workshopCoachAssit: values
      });
      this.workshopEditForm.get('workshopCoachAssit').updateValueAndValidity();
      // // console.log(this.workshopEditForm.value.workshopCoachAssit);
      // // console.log(this.workshopData.WORKSHOP_COACH_ASSIT);

    } else {
      // create workshop
      this.workshopForm.patchValue({
        workshopCoachAssit: values
      });
      this.workshopForm.get('workshopCoachAssit').updateValueAndValidity();
      // // console.log(this.workshopForm.value.workshopCoachAssit);
    }
  }

  checkStatus(event) {
    this.workshopForm.patchValue({
      statusPublic: event.checked
    });
    this.workshopForm.get('statusPublic').updateValueAndValidity();
  }

  getAllLearning() {
    this.learningCenterService.getAllLearningCenterAdmin().subscribe(
      res => {
        res.result.forEach(e => {
          this.allLearningCenter.push({
            CENTER_NAME: e.CENTER_NAME,
            CENTER_ID: e.CENTER_ID,
          })
        })
      });
  }

  patchLearning(val, form) {
    let value = [];
    value = val.listOfValue;
    form.patchValue({
      centerId: value
    });
    form.get('centerId').updateValueAndValidity();
    // console.log(form.value);
  }

  compareLNFn(i1: any, i2: any): boolean {
    return i1 && i2 ? i1.CENTER_ID === i2.CENTER_ID : i1 === i2;
  }
}
